var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6666 5.49341L8.87325 5.08008L6.99992 0.666748L5.12659 5.08675L0.333252 5.49341L3.97325 8.64675L2.87992 13.3334L6.99992 10.8467L11.1199 13.3334L10.0333 8.64675L13.6666 5.49341ZM6.99992 9.60008L4.49325 11.1134L5.15992 8.26008L2.94659 6.34008L5.86659 6.08675L6.99992 3.40008L8.13992 6.09342L11.0599 6.34675L8.84659 8.26675L9.51325 11.1201L6.99992 9.60008Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon_star.c32619360193cebf590518a686497f27.svg";
export { ForwardRef as ReactComponent };